<template>
  <echarts :options="options" class="chart-stage"></echarts>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  components: {
    echarts
  },
  props: {
    category: {
      type: Array,
    },
    area: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      required: true
    },
    grid: {
      type: Object,
      default() {
        return {}
      }
    },
    unit: {
      type: String,
      default: ''
    },
    unitX: {
      type: String,
      default: ''
    }
  },
  created(){
    // [创建vue实例时]获取当前模式与主题下的图表颜色系列
    this.getEchartsColor();
  },
  data () {
    return {
      // ====================================
      // 深true|浅false
      tmpModeFlag : (String(localStorage.getItem("modeFlag")) == "true" ? true : false),
      // tmpThemeColorFlag : (localStorage.getItem("themeColorFlag") || "mt-blue"),
      // ====================================
      // 注：legend(线)使用rgba会出现悬浮时图例消失的情况
      // 发电rgb(216, 24, 59)、用电-负载rgb(255, 108, 26)、买电-电网rgb(218, 222, 39)、
      // 卖电rgb(141, 222, 38)、充电-电池rgb(31, 206, 164)、放电rgb(33, 156, 225)
      // lineColor: [
      //   'rgb(216, 24, 59, 1)', 'rgb(255, 108, 26, 1)', 
      //   'rgb(218, 222, 39, 1)','rgb(141, 222, 38, 1)',
      //   'rgb(31, 206, 164, 1)', 'rgb(33, 156, 225, 1)'
      // ],
      // 此处不支持变量！（默认浅色）
      areaColor: [
        // [@blue：深rgba(154, 202, 255, 0.15)|浅rgba(81, 149, 218, 0.15)]
        'rgba(81, 149, 218, 0.15)', 
        // [@rose：深rgba(255, 178, 187, 0.15)|浅rgba(255, 79, 114, 0.15)]
        'rgba(255, 79, 114, 0.15)',
      ],
      // 此处不支持变量！（默认浅色）
      lineColor: [
        // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
        'rgba(81, 149, 218, 1)', 
        // [@rose：深rgba(255, 178, 187, 1)|浅rgba(255, 79, 114, 1)]
        'rgba(255, 79, 114, 1)',
      ],
      // areaColor: [
      //   '#f7d0d7', '#ff1a43ff', 
      //   '#f7f8d3','#e8f8d3',
      //   '#d2f5ec', '#d2ebf9'
      // ],
      // 十六进制颜色
      // lineColor: ['#ff7c79', '#f19149', '#22ac38','#00a0e9'],
      // areaColor: ['#fed9d8', '#fbdfca', '#bde7c4','#bde7f9']

      // =======================================
      // 将options中所有与颜色相关（即换肤相关）的，
      // 在data中定义，在watch中重新赋值。
      // .......................................
      // (深#9ACAFF|浅#5195DA)
      // color: this.tmpModeFlag?'#9ACAFF':'#5195DA',
      // ['#9ACAFF', '#FFB2BB',] ['#5195DA', '#FF4F72',]
      // seriesItemStylEmphasisColor: 
      //   String(localStorage.getItem("modeFlag")) == 'true' ? ['#9ACAFF', '#FFB2BB', 'yellow'] : ['#5195DA', '#FF4F72', 'purple'],
      // .............
      // 默认浅色
      // .............
      // seriesItemStylEmphasisColor: ['purple', 'orange'],
      // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
      seriesItemStylEmphasisBorderColor: 'rgba(251, 253, 248, 0.5)',
      tooltipBackgroundColor: 'rgba(251,253,252,0.9)',
      tooltipTextStyleColor: 'rgba(25,28,26,1)',
      legendTextStyleColor: 'rgba(25,28,26,1)',
      legendInactiveColor: '#C0C9C2',
      // [@outline:深#89938C|浅#707973]
      xAxisAxisLineLineStyleColor: '#707973',
      // [@onsurfacevariant：深#C0C9C2|浅#404943]
      xAxisAxisLabelColor: '#404943',
      // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
      xAxisAxisPointerLineStyleColor: 'rgba(0, 136, 96, 0.16)',
      // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
      yAxisSplitLineLineStyleColor: 'rgba(0, 136, 96, 0.08)',
      // [L5：深#000|浅#000（阴影色值相同但参数有异）]
      // 深：0px 14px 28px rgba(0,0,0,48%),
      //    0px 0px 8px rgba(0,0,0,40%);
      // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
      //    0px 12.8px 28.8px rgba(0,0,0,13%);
      tooltipExtraCssText: 'box-shadow: 0px 2.4px 7.4px rgba(0,0,0,11%), 0px 12.8px 28.8px rgba(0,0,0,13%)', 
      // =======================================
    }
  },
  computed: {
    // 此处也不支持变量
    // 此处是监听图表渲染参数（只对其中的颜色做处理，其它保持原样）
    // 用深浅模式标志对该参数内部颜色进行处理（tmpModeFlag：深true|浅false）
    // 问题是此处在换肤切换后不会自动更新！！！
    options() {
      let series = [], legends = []
      this.data.forEach((ele, index) => {
        let serieData = []
        legends.push(ele.name)
        ele.value.forEach((item, i) => {
          // 接收的category
          serieData.push([this.category[i], item])
        })
        // series
        series.push({
          name: ele.name,
          type: 'line',
          data: serieData,
          // 设置小圆点消失
          // 注意：设置symbol: 'none'以后，拐点不存在了，设置拐点上显示数值无效
          symbol: 'none',
          // 设置折线弧度，取值：0-1之间，(true有弧度)
          smooth: 0,
          // ..........................
          // 面积
          areaStyle: {
            // color: this.area ? this.areaColor[index] : 'transparent'
            color: "rgba(221,104,67,0.15)"
          },
          // ..........................
          // 折线（前面已设置不同色）
          // 注：可设置重叠面积的各自边线样式
          // lineStyle:{
          //   normal:{
          //     // 折线颜色
          //     // color:'red',
          //     // 折线粗细
          //     width:'10',
          //   }
          // },
          // ...........................
          // 拐点
          // 拐点设为实心
          symbol:'circle',
          //拐点大小（无论默认或悬浮，所以设为1）
          symbolSize:1,
          //false:hover圆点不缩放 | true:hover圆点默认缩放
          animation: true,
          itemStyle:{
            normal:{
              // 拐点颜色（前面已设置不同色）
              // color:'',
              // 拐点边框颜色（此处不设置）
              // borderColor:'',
              // 拐点边框大小设为0
              borderWidth:0,
              // 连线
              // 使用rgba设置折线透明度为0，可以视觉上隐藏折线
              // 注：可设置重叠面积的各自边线样式
              lineStyle:{
                // 设置线宽
                width:1,
                //'dotted'虚线 'solid'实线
                // type:'dotted',
                color:"#EC3030"

              },
            },
            emphasis: {
              // 悬浮拐点颜色
              // (深#9ACAFF|浅#5195DA)
              // color: this.tmpModeFlag?'#9ACAFF':'#5195DA',
              // color: this.seriesItemStylEmphasisColor,
              // color:()=>{},
              // 悬浮拐点边框颜色
              // borderColor:'rgba(81,149,218,0.2)',
              // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
              borderColor: this.seriesItemStylEmphasisBorderColor,
              // 悬浮拐点边框大小
              // borderWidth: 20,
              color:"#EC3030",
              // 阴影
              // shadowColor: 'rgba(0, 0, 0, 1)',
              // 阴影模糊程度
              // shadowBlur: 10,
            }
          },
          // ...........................
        })
      });

      let grid = {
        ...{
          top: "45",
          left: "60",
          right: "30",
          // ===
          bottom: "70"
        }, ...this.grid
      };

      return {
        color: "#EC3030",
        tooltip: {
          trigger: "axis",
          // 浮窗背景
          // backgroundColor: "rgb(251,253,252,0.9)",
          backgroundColor: "rgba(45,63,75,0.9)",
          // 浮窗边框
          borderColor: "transparent",
          borderWidth: "1",
          textStyle: {
            // color: '#191C1A',
            color: "#ADB9C0",
            fontSize: 12
          },
          axisPointer: {
            // #################################
            // 柱状悬浮显示蒙版，折线图悬浮显示线条
            // #################################
            type: "line",
            label: {
              formatter: function (params) {
                if (params.seriesData.length === 0) {
                  window.mouseCurValue = params.value;
                }
              }
            },
          },
          // 10
          borderRadius: 4,
          // 提示框位置（使用默认就很合适！）
          // position: function (pt) {
          //   // 水平，垂直
          //   return [pt[0]-0, -20];
          // },
          // position: function (pos, params, dom, rect, size) {
          //   // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧
          //   var obj = {top: 60};
          //   obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
          //   return obj;
          // },
          // 提示框阴影
          // 额外附加到浮层的 css 样式
          // [L5：深#000|浅#000（阴影色值相同但参数有异）]
          // 深：0px 14px 28px rgba(0,0,0,48%),
          //    0px 0px 8px rgba(0,0,0,40%);
          // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
          //    0px 12.8px 28.8px rgba(0,0,0,13%);
          extraCssText: this.tooltipExtraCssText, 
          // 是否将 tooltip 框限制在图表的区域内
          // confine: true, 
          // 格式化数据
          formatter: function(params, ticket, callback) {
            // console.log("formatter-params：", params);
            // ..........................................
            let tooltipItems = '';
            let tooltipHead = '' + '<br/>';
            for (let index in params) {
              tooltipHead = params[index].value[0].slice(0,11) + '<br/>';
              // marker + color
              tooltipItems += "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:6px;height:6px;background-color:" + 
                params[index].color+"'></span>" + 
                params[index].seriesName + 
                "：" + 
                params[index].value[1] + 
                '<br>';
            }
            return tooltipHead + tooltipItems;
          }
        },
        legend: {
          itemWidth: 16,
          itemHeight: 8,
          bottom: '20',
          data: legends,
          selectedMode: 'multiple',
          textStyle: {
            color: '#ffffff',
            // color: this.legendTextStyleColor,
          },
          // 图例关闭时颜色
          // inactiveColor: "#7b8395",
          inactiveColor: this.legendInactiveColor,
          // ..................
          // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
          icon: 'rect',
          // icon: "image://./echarts/myLegend.svg",
          // icon: 'image://https://p.ssl.qhimg.com/dm/40_40_/d/inn/3716a4d4/1-0.png',
          // ..................
        },
        grid,
        xAxis: [
          {
            type: 'time',
            name: this.unitX,
            axisLine: {
              lineStyle: {
                // color: 'rgba(123, 131, 149, 1)',
                // [@outline:深#89938C|浅#707973]
                color: this.xAxisAxisLineLineStyleColor,
                type: 'solid',
                width: 2,
              }
            },
            axisLabel: {
              // interval: 0,
              // color: 'rgba(64, 73, 67, 1)',
              // [@onsurfacevariant：深#C0C9C2|浅#404943]
              // color: this.xAxisAxisLabelColor,
              color: "#ADB9C0",
              // 只显示日过滤掉年月时分
              formatter: (value) => {
                return this.$filter.formatDate(new Date(value)).slice(8,10)
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                // color: 'rgba(123, 131, 149, 1)',
                color: 'transparent',
              }
            },
            // 该轴分割数
            splitNumber: 7,
            // 步长
            // interval:1, 
            // 终止
            // max: (value) => {
            //   return new Date(this.$filter.formatDate(new Date(value.max), 'yyyy-MM-dd') + ' 24:00:00').getTime()
            // },
            // 起始
            // min: (value) => {
            //   return new Date(this.$filter.formatDate(new Date(value.min), 'yyyy-MM-dd') + ' 00:00:00').getTime()
            // },
            // 悬浮（线条）
            axisPointer: {
              type: 'line',
              lineStyle: {
                // color: 'rgba(0, 136, 96, 0.16)',
                // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
                // color: this.xAxisAxisPointerLineStyleColor,
                color: "#EC3030",
                width: 1,
              }
            },
            axisTick: {
              // 显示刻度线
              show: true,
              // 刻度齿对准值
              alignWithLabel: true,
            },
          }
        ],
        yAxis: [
          {
            type: "value",
            // 此处显示需要Y轴axisLineY轴线显示
            name: this.unit,
            axisLine: {
              lineStyle: {
                // color: 'rgba(123, 131, 149, 1)',
                // color: 'transparent',
                type: 'dashed',
                width: 0,
              }
            },
            axisLabel: {
              // color: 'rgba(64, 73, 67, 1)',
              // 此处借用X轴
              // [@onsurfacevariant：深#C0C9C2|浅#404943]
              // color: this.xAxisAxisLabelColor,
              color: "#ADB9C0",
              // formatter: this.unit,
            },
            axisPointer: {
              show: false,
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                // color: 'rgba(123, 131, 149, 1)',
                // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
                // color: this.yAxisSplitLineLineStyleColor,
                color: "#556570",
              }
            }
          }
        ],
        series
      }
    }
  },
  watch: {
    // tmpModeFlag(val){
    //   if(val){
    //     console.log("watch-tmpModeFlag");
    //   }
    // },
    // 响应更新换肤事件
    "$store.state.event.updateSkin"(val) {
      if (val) {
        // console.log("刷新本页");
        location.reload();
        // ....................................
        // true深色 | false 浅色
        let tmpMode =
          String(localStorage.getItem("modeFlag")) == "true" ? true : false;
        // 各种主题色
        // let tmpThemeColor = localStorage.getItem("themeColorFlag") || "mt-blue";
        // ....................................
        // 一个项目一个主题色，仅做深浅模式切换
        // 深-蓝
        // &&tmpThemeColor=='mt-blue'
        if(tmpMode){
          this.lineColor = [
            // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
            'rgba(154, 202, 255, 1)', 
            // [@rose：深rgba(255, 178, 187, 1)|浅rgba(255, 79, 114, 1)]
            'rgba(255, 178, 187, 1)',
          ];
          this.areaColor = [
            // [@blue：深rgba(154, 202, 255, 0.15)|浅rgba(81, 149, 218, 0.15)]
            'rgba(154, 202, 255, 0.15)', 
            // [@rose：深rgba(255, 178, 187, 0.15)|浅rgba(255, 79, 114, 0.15)]
            'rgba(255, 178, 187, 0.15)',
          ];
          // ****************
          // (深#9ACAFF|浅#5195DA)
          // this.seriesItemStylEmphasisColor = ['#9ACAFF', '#FFB2BB', 'yellow'];
          // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
          this.seriesItemStylEmphasisBorderColor = '(25, 28, 26, 0.5)';
          // #191C1A
          this.tooltipBackgroundColor = 'rgba(25,28,26,0.9)';
          // #FBFDFC
          this.tooltipTextStyleColor = 'rgba(251,253,252,0.9)';
          // #FBFDFC
          this.legendTextStyleColor = 'rgba(251,253,252,0.9)';
          // #707973
          this.legendInactiveColor = '#707973';
          // [@outline:深#89938C|浅#707973]
          this.xAxisAxisLineLineStyleColor = '#89938C';
          // [@onsurfacevariant：深#C0C9C2|浅#404943]
          this.xAxisAxisLabelColor = '#C0C9C2';
          // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
          this.xAxisAxisPointerLineStyleColor = 'rgba(108, 219, 172, 0.16)';
          // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
          this.yAxisSplitLineLineStyleColor = 'rgba(108, 219, 172, 0.08)';
          // [L5：深#000|浅#000（阴影色值相同但参数有异）]
          // 深：0px 14px 28px rgba(0,0,0,48%),
          //    0px 0px 8px rgba(0,0,0,40%);
          // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
          //    0px 12.8px 28.8px rgba(0,0,0,13%);
          this.tooltipExtraCssText = 'box-shadow: 0px 14px 28px rgba(0,0,0,48%), 0px 0px 8px rgba(0,0,0,40%)';
          // ****************
        }
        // 浅-蓝
        // &&tmpThemeColor=='mt-blue'
        if(!tmpMode){
          this.lineColor = [
            // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
            'rgba(81, 149, 218, 1)', 
            // [@rose：深rgba(255, 178, 187, 1)|浅rgba(255, 79, 114, 1)]
            'rgba(255, 79, 114, 1)',
          ];
          this.areaColor = [
            // [@blue：深rgba(154, 202, 255, 0.15)|浅rgba(81, 149, 218, 0.15)]
            'rgba(81, 149, 218, 0.15)', 
            // [@rose：深rgba(255, 178, 187, 0.15)|浅rgba(255, 79, 114, 0.15)]
            'rgba(255, 79, 114, 0.15)',
          ];
          // ****************
          // (深#9ACAFF|浅#5195DA)
          // this.seriesItemStylEmphasisColor = ['#5195DA', '#FF4F72', 'purple'];
          // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
          this.seriesItemStylEmphasisBorderColor = 'rgba(251, 253, 248, 0.5)';
          // #FBFDFC
          this.tooltipBackgroundColor = 'rgba(251,253,252,0.9)';
          // #191C1A
          this.tooltipTextStyleColor = 'rgba(25,28,26,0.9)';
          // #191C1A
          this.legendTextStyleColor = 'rgba(25,28,26,0.9)';
          // #C0C9C2
          this.legendInactiveColor = '#C0C9C2';
          // [@outline:深#89938C|浅#707973]
          this.xAxisAxisLineLineStyleColor = '#707973';
          // [@onsurfacevariant：深#C0C9C2|浅#404943]
          this.xAxisAxisLabelColor = '#404943';
          // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
          this.xAxisAxisPointerLineStyleColor = 'rgba(0, 136, 96, 0.16)';
          // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
          this.yAxisSplitLineLineStyleColor = 'rgba(0, 136, 96, 0.08)';
          // [L5：深#000|浅#000（阴影色值相同但参数有异）]
          // 深：0px 14px 28px rgba(0,0,0,48%),
          //    0px 0px 8px rgba(0,0,0,40%);
          // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
          //    0px 12.8px 28.8px rgba(0,0,0,13%);
          this.tooltipExtraCssText = 'box-shadow: 0px 2.4px 7.4px rgba(0,0,0,11%), 0px 12.8px 28.8px rgba(0,0,0,13%)';
          // ****************
        }
        // ....................................
        // 重置该事件状态
        this.$store.state.event.updateSkin = false;
      }
    },
  },
  methods: {
    // [创建vue实例时]获取当前模式与主题下的图表颜色系列
    getEchartsColor(){
      // ....................................
      // true深色 | false 浅色
      let tmpMode =
        String(localStorage.getItem("modeFlag")) == "true" ? true : false;
      // 各种主题色
      // let tmpThemeColor = localStorage.getItem("themeColorFlag") || "mt-blue";
      // ....................................
      // 一个项目一个主题色，仅做深浅模式切换
      // 深-蓝
      // &&tmpThemeColor=='mt-blue'
      if(tmpMode){
        this.lineColor = [
          // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
          'rgba(154, 202, 255, 1)', 
          // [@rose：深rgba(255, 178, 187, 1)|浅rgba(255, 79, 114, 1)]
          'rgba(255, 178, 187, 1)',
        ];
        this.areaColor = [
          // [@blue：深rgba(154, 202, 255, 0.15)|浅rgba(81, 149, 218, 0.15)]
          'rgba(154, 202, 255, 0.15)', 
          // [@rose：深rgba(255, 178, 187, 0.15)|浅rgba(255, 79, 114, 0.15)]
          'rgba(255, 178, 187, 0.15)',
        ];
        // ****************
        // (深#9ACAFF|浅#5195DA)
        this.seriesItemStylEmphasisColor = ['#9ACAFF', '#FFB2BB', 'yellow'];
        // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
        this.seriesItemStylEmphasisBorderColor = 'rgba(25, 28, 26, 0.5)';
        // #191C1A
        this.tooltipBackgroundColor = 'rgba(25,28,26,0.9)';
        // #FBFDFC
        this.tooltipTextStyleColor = 'rgba(251,253,252,1)';
        // #FBFDFC
        this.legendTextStyleColor = 'rgba(251,253,252,1)';
        // #707973
        this.legendInactiveColor = '#707973';
        // [@outline:深#89938C|浅#707973]
        this.xAxisAxisLineLineStyleColor = '#89938C';
        // [@onsurfacevariant：深#C0C9C2|浅#404943]
        this.xAxisAxisLabelColor = '#C0C9C2';
        // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
        this.xAxisAxisPointerLineStyleColor = 'rgba(108, 219, 172, 0.16)';
        // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
        this.yAxisSplitLineLineStyleColor = 'rgba(108, 219, 172, 0.08)';
        // [L5：深#000|浅#000（阴影色值相同但参数有异）]
        // 深：0px 14px 28px rgba(0,0,0,48%),
        //    0px 0px 8px rgba(0,0,0,40%);
        // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
        //    0px 12.8px 28.8px rgba(0,0,0,13%);
        this.tooltipExtraCssText = 'box-shadow: 0px 14px 28px rgba(0,0,0,48%), 0px 0px 8px rgba(0,0,0,40%)';
        // ****************
      }
      // 浅-蓝
      // &&tmpThemeColor=='mt-blue'
      if(!tmpMode){
        this.lineColor = [
          // [@blue：深rgba(154, 202, 255, 1)|浅rgba(81, 149, 218, 1)]
          'rgba(81, 149, 218, 1)', 
          // [@rose：深rgba(255, 178, 187, 1)|浅rgba(255, 79, 114, 1)]
          'rgba(255, 79, 114, 1)',
        ];
        this.areaColor = [
          // [@blue：深rgba(154, 202, 255, 0.15)|浅rgba(81, 149, 218, 0.15)]
          'rgba(81, 149, 218, 0.15)', 
          // [@rose：深rgba(255, 178, 187, 0.15)|浅rgba(255, 79, 114, 0.15)]
          'rgba(255, 79, 114, 0.15)',
        ];
        // ****************
        // (深#9ACAFF|浅#5195DA)
        this.seriesItemStylEmphasisColor = ['#5195DA', '#FF4F72', 'purple'];
        // [@surface:深rgba(25, 28, 26, 0.5)|浅rgba(251, 253, 248, 0.5)]
        this.seriesItemStylEmphasisBorderColor = 'rgba(251, 253, 248, 0.5)';
        // #FBFDFC
        this.tooltipBackgroundColor = 'rgba(251,253,252,0.9)';
        // #191C1A
        this.tooltipTextStyleColor = 'rgba(25,28,26,1)';
        // #191C1A
        this.legendTextStyleColor = 'rgba(25,28,26,1)';
        // #C0C9C2
        this.legendInactiveColor = '#C0C9C2';
        // [@outline:深#89938C|浅#707973]
        this.xAxisAxisLineLineStyleColor = '#707973';
        // [@onsurfacevariant：深#C0C9C2|浅#404943]
        this.xAxisAxisLabelColor = '#404943';
        // [@primary：深rgba(108, 219, 172, 0.16)|浅rgba(0, 136, 96, 0.16)]
        this.xAxisAxisPointerLineStyleColor = 'rgba(0, 136, 96, 0.16)';
        // [@primary：深rgba(108, 219, 172, 0.08)|浅rgba(0, 136, 96, 0.08)]
        this.yAxisSplitLineLineStyleColor = 'rgba(0, 136, 96, 0.08)';
        // [L5：深#000|浅#000（阴影色值相同但参数有异）]
        // 深：0px 14px 28px rgba(0,0,0,48%),
        //    0px 0px 8px rgba(0,0,0,40%);
        // 浅：0px 2.4px 7.4px rgba(0,0,0,11%),
        //    0px 12.8px 28.8px rgba(0,0,0,13%);
        this.tooltipExtraCssText = 'box-shadow: 0px 2.4px 7.4px rgba(0,0,0,11%), 0px 12.8px 28.8px rgba(0,0,0,13%)';
        // ****************
      }
      // ....................................
    }
  },
};
</script>
<style lang="less" scoped>
.chart-stage {
  height: 100%;
  // background: red;
  // background: @chartbgcblue;
}
</style>